module.exports = __webpack_public_path__ + "assets/img/vuex_mutations.1f0e8eda.jpg";